import type { EventTransport, WidgetEventEnvelope } from "./transport";

export type EventSender = (
  envelope: WidgetEventEnvelope,
) => Promise<void> | void;

export function createImmediateSender(transport: EventTransport): EventSender {
  return (envelope) => Promise.resolve(transport(envelope)).catch(() => {});
}
